import type { Ref } from "vue";

/**
 * Toggle a value in an array - if it exists, remove it; if not, add it
 * Works with Vue refs that contain arrays
 */
export function toggleArrayValue<T>(arrayRef: Ref<T[]>, value: T): void {
  const index = arrayRef.value.indexOf(value);
  if (index !== -1) {
    arrayRef.value.splice(index, 1);
  } else {
    arrayRef.value.push(value);
  }
}

/**
 * Pure function version that returns a new array instead of mutating
 */
export function toggleInArray<T>(array: T[], value: T): T[] {
  const index = array.indexOf(value);
  if (index !== -1) {
    return array.filter((_, i) => i !== index);
  }
  return [...array, value];
}
